// extracted by mini-css-extract-plugin
module.exports = {"loading":"PublicCertificatePage_loading__4K6zm"};